module.exports = __webpack_public_path__ + "static/media/eawag.d3878b1d.png";